import { Dangerous } from '@styled-icons/material-outlined/Dangerous';
import { ResponsivenessWrapper } from '~/components';

import * as S from './styles';
import { Button } from '@getinapp/appetizer';
import type { FunctionComponent } from 'react';

type NotFoundProps = {
  hasTryAgainButton?: boolean;
};

const NotFound: FunctionComponent<NotFoundProps> = (props) => {
  const { hasTryAgainButton = true } = props;

  return (
    <ResponsivenessWrapper>
      <S.Container>
        <S.WrapperInfo>
          <Dangerous size={60} />
          <p>
            Página não encontrada, tente novamente com o botão abaixo. Caso o
            erro persista, dirija-se à hostess para ser atendido.
          </p>
        </S.WrapperInfo>
        {hasTryAgainButton && (
          <Button onClick={() => window.location.reload()}>
            Tentar novamente
          </Button>
        )}
      </S.Container>
    </ResponsivenessWrapper>
  );
};

export default NotFound;
